module.exports = __webpack_public_path__ + "static/media/lp1.f0099cb5.jpg";